export const SIMULATION_CONSTANTS = {
  DEFAULT_DURATION_SECONDS: 600, // 10 minutes
  LOW_TIME_WARNING_SECONDS: 60,  // 1 minute
  DEFAULT_LANGUAGE: 'en-US',
  SPEECH_RECOGNITION_LANG: 'en-US',
  DEFAULT_PERSONA_NAME: 'AI Persona',
  DEFAULT_SCENARIO_TITLE: 'AI Conversational Simulation',
  AUDIO_FFT_SIZE: 64,
  AUDIO_ACTIVITY_THRESHOLD: 15,
};

export const SIMULATION_STATE_LABELS: Record<string, string> = {
  initializing: 'Initializing Simulation...',
  ready: 'Simulation Ready',
  starting: 'Starting Attempt...',
  listening: 'Listening to your response...',
  processing: 'AI is thinking...',
  ai_speaking: 'AI is speaking...',
  paused: 'Simulation Paused',
  completing: 'Concluding & Evaluating...',
  completed: 'Simulation Completed',
  error: 'Simulation Error',
};
